import React from 'react';
import {useStyles, Coin} from './helper';
import { translate } from '../../dictionaries';

const Footer = () => {
    const classes = useStyles();

    return (
        <div className={classes.root} style={{position: 'relative'}}>
            <div className={classes.wrapLeft}>
                <span className={classes.text}>
                    © WIN777
                </span>
                <span className={classes.text}>
                    {translate('common.copyright')}
                </span>
            </div>
            <div className={classes.wrapRight}>
                <span className={classes.text18}>18+</span>
            </div>
            <div className={classes.wrapCoin}>
                <Coin />
            </div>
        </div>
    )
}

export default Footer;